import React, { ReactNode } from "react";
import { motion, useReducedMotion, Variants } from "framer-motion";
import { fadeUp } from "../../styles/animations";

interface RevealProps {
    children: ReactNode;
    variant?: Variants;
    delay?: number;
    className?: string;
}

const Reveal = (props: RevealProps) => {
    const prefersReducedMotion = useReducedMotion();
    const variant = props.variant ?? fadeUp;

    if (prefersReducedMotion) {
        return <div className={props.className}>{props.children}</div>;
    }

    return (
        <motion.div
            className={props.className}
            variants={variant}
            custom={props.delay ?? 0}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-80px" }}
        >
            {props.children}
        </motion.div>
    );
};

export default Reveal;
